// TaskRow (job page round): a follow-up that outlives the visits ("Book the city gas inspection"), ticked
// off with a Checkbox: what to do, then who and by when under it. One past its date says so in red
// (DESIGN.md §2: it needs someone now); a done one says when. Reads only --task-*; Checkbox its own.
import { Checkbox } from '../Checkbox/Checkbox.tsx';
import './TaskRow.css';

export interface TaskRowProps {
  title: string;
  /** Who it's for ("Dana"). */
  who?: string;
  /** When it's due, in words ("Thu Oct 29"). */
  due?: string;
  isOverdue?: boolean;
  /** Done: when ("Sat Oct 24"). */
  doneOn?: string;
  isDone?: boolean;
  onChange?: (done: boolean) => void;
  isDisabled?: boolean;
}

export function TaskRow({
  title,
  who,
  due,
  isOverdue,
  doneOn,
  isDone = false,
  onChange,
  isDisabled,
}: TaskRowProps) {
  const when = isDone
    ? doneOn
      ? `done ${doneOn}`
      : 'done'
    : due
      ? isOverdue
        ? `overdue, was due ${due}`
        : `due ${due}`
      : null;
  const meta = [who, when].filter(Boolean).join(' · ');
  return (
    <div
      className="fl-task"
      data-overdue={isOverdue && !isDone ? '' : undefined}
      data-done={isDone ? '' : undefined}
    >
      <Checkbox isSelected={isDone} onChange={onChange} isDisabled={isDisabled}>
        <span className="fl-task__title">{title}</span>
        {meta ? <span className="fl-task__meta">{meta}</span> : null}
      </Checkbox>
    </div>
  );
}
